import {useEffect, useState} from 'react';
import {Badge, Button, Col, Image, Row} from 'react-bootstrap';
import ichWerdeTierSein from '../../images/ich-werde-tier-sein.jpg'
import sepidarTeam from '../../images/sepidar-team.jpg'
import kuturBueroUndStadtDortmund from '../../images/kulturbuero-und-stadt-dortmund.jpeg'
import lwl from '../../images/lwl.jpeg'

import Carousel from 'react-bootstrap/Carousel';


const CarouselFadeExample = () => {
  const images = [
    { src: ichWerdeTierSein, alt: 'Ich werde Tier Sein' },
  ];
  return (
    <Carousel id='home-slider' fade controls={false} indicators={false} style={{borderRadius: '25px'}}>
      {images.map((image, index) => (
        <Carousel.Item key={index} interval={4000}>
          <img
            className="d-block w-100"
            src={image.src}
            alt={image.alt}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default CarouselFadeExample;
export const Home = () => {

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <div>
      <Row>
        <Col xs={12} lg={7} className="d-flex flex-column justify-content-end mb-5">
          <h1 className='display-1 fw-bold'>Ich werde Tier sein</h1>
          <p className='fs-3 fw-light' style={{flexGrow: '1'}}>
            …erzählt mit Mitteln des Physical Theatre, Musik, Licht- und Schattenspiel von der menschlichen Existenz im existentiellen Wandel.
          </p>
          <h3 className='display-6'><Badge bg="secondary">Theater im Depot, Dortmund</Badge></h3>
          <h4 className="d-flex align-items-center"><span className='display-6'>21.02.2025</span><Badge bg="info" style={{margin: '0 7px'}}>PREMIERE</Badge><span className='display-6'>&</span></h4>
          <h4 className='display-6'>22.02.2025</h4>
          <div>
            <Button variant="light" size="lg" href="https://theaterimdepot.de/de/programm/kalender/ich-werde-tier-sein" target="_blank" rel="noopener noreferrer">
              Tickets
            </Button>
          </div>
          <blockquote className="blockquote mt-1">
            <p></p>
            <footer className="blockquote-footer">
              15 €, ermäßigt 10 €
            </footer>
          </blockquote>
        </Col>
        <Col xs={12} lg={5} className="mb-5">
          {CarouselFadeExample()}
        </Col>
      </Row>
      <Row>
          <p className='fs-4 fw-light'>Auf der Bühne kreucht und fleucht, scharrt und krächzt es – tierische Mischwesen begegnen dem Publikum in surrealem Zwielicht. Wo sind wir immer Tier gewesen und geblieben? Was macht den Mensch zum Menschen? Sepidar Theater rückt den entfremdeten Menschen in ein animalisches Licht, das Potentiale, Überraschungen und Verwerfungen birgt. „Ich werde Tier sein“ dreht sich um die Metapher der Mensch-Tier-Verwandlung für existentielle Zustände, in denen sich der Mensch befindet. Kapitalismus, Krieg, Krise – die Gesellschaft entfremdet den Menschen in vielfacher Hinsicht. Das Sepidar Theater befragt den Mensch-Tier-Hybriden, was er mit diesen Zuständen zu tun hat und ob er Folge oder Ausweg aus der modernen Entfremdung sein kann.</p>
      </Row>
      <Row>
        <Col xs={12} lg={7} className="mb-5">
          <p className='fs-5 mt-5'>Cast & Credits</p>
          <p className='fs-5 mt-5'>
            Künstlerische Leitung, Performance & Regie: <strong> Mamadoo Mehrnejad & Bahareh Sadafi </strong><br/>
            Musik und Komposition: <strong> Amir Reza Edalat Nobarzad </strong><br/>
            Dramaturgie und Produktion: <strong> Aylin Kreckel </strong><br/>
            Recherche & Assistenz: <strong> Maedeh Mirzaei </strong><br/>
            Technik: <strong> Björn Nienhuys </strong><br/>
          </p>
        </Col>
        <Col xs={12} lg={5} className="mb-5">
          <Image src={sepidarTeam} alt='Sepidar Team' fluid />
        </Col>
      </Row>
      <Row className="d-flex align-items-center justify-content-center p-3 bg-white">
        <Col xs={12} lg={6} className="d-flex justify-content-lg-end justify-content-md-center justify-content-sm-center">
          <div>
            <img style={{maxWidth: "450px", width: "100%"}} src={kuturBueroUndStadtDortmund} alt="Kultur Büro und Stadt Dortmund"/>
          </div>
        </Col>
        <Col xs={12} lg={4}>
            <a style={{width: "100%"}} href={"https://www2.lwl.org/de/LWL"} target="_blank">
              <div >
                <img style={{display: "block"}} className="m-auto" width={"250px"} src={lwl} alt="LWL Für die Menschen. Für Westfalen-Lippe"/>
              </div>
            </a>
        </Col>
      </Row>
    </div>
  )
}